import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import MessagesUtil from "../../tinode/messagesUtils";
import * as MC_CONST from '../../tinode/constants'
import { IconClose } from "../../icons/svg";
import { Tinode } from "../../tinode/tinode";
import LetterTile from "../letter-tile.jsx";
import lodash from 'lodash'

const messages = defineMessages({
  dilog_react_message: {
    id: "dilog_react_message",
    defaultMessage: "Rename the group",
    description: "Rename the group",
  },
})

class ReactMessage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.reactMember = this.reactMember.bind(this);
    this.getTotalMotion = this.getTotalMotion.bind(this);
  }

  reactMember(item, key) {
    const { tinode } = this.props;
    const topic = MessagesUtil.getTopicId(MC_CONST.NODE_TYPE_MESSAGE.CHAT, item?.member);
    const topicInfo = tinode.getTopicByName(topic, {
      isCreateWhenNotExist: true
    });
    const avatar = lodash.has(topicInfo, 'public.photo.ref') ? topicInfo.public.photo.ref : true;
    return (
      <div className="item" key={key}>
        <div className="left">
          <div className="avatar">
            <LetterTile
              tinode={tinode}
              avatar={avatar}
              topic={topicInfo}
              title={topicInfo?.getTopicName()} />
          </div>
          <div className="name">{topicInfo.getTopicName()}</div>
        </div>
        <div className="right">
          <div className="icon">{Tinode.MESSAGE_EMOTIONS.find(v => v.id == item?.motionId).icon}</div>
          {/* <div className="number">{item.}</div> */}
        </div>
      </div>
    )
  }

  getTotalMotion() {
    const { motions } = this.props
    try {
      if (motions && motions.length > 0) {
        return motions.length;
      }
    } catch (error) { }
    return 0
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { motions, onClose } = this.props
    return (
      <Suspense
        fallback={
          <div className="panel-form-row">
            <FormattedMessage
              id="loading_note"
              defaultMessage="Loading..."
              description="Message shown when component is loading"
            />
          </div>
        }>
        <div className="dialog-react">
          <div className="header">
            <div className="icon"></div>
            <div className="title">
              {formatMessage(messages.dilog_react_message, { number: this.getTotalMotion() })}
            </div>
            <div className="icon" onClick={onClose}>
              <IconClose />
            </div>
          </div>
          <div className="content">
            <div className="list-react">
              {motions && motions.map((item, key) => {
                return this.reactMember(item, key);
              })}
            </div>
          </div>
        </div>
      </Suspense>
    )
  }
}
export default injectIntl(ReactMessage);